import axios from "axios";
import { parseISO } from "date-fns";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { AccountType, Custodian, CustodianAccountId, OperationalState, PhysicalAccountId, VirtualAccountId, } from "../../Types";
import ValidationError from "../../ZodError";
const PhysicalAccountSchema = z.object({
    physicalAccountId: PhysicalAccountId,
    brokerageType: z.enum(["Cash", "Margin"]),
    accountType: AccountType,
    virtualAccountId: VirtualAccountId,
    custodian: Custodian,
    custodianAccountId: CustodianAccountId.nullable(),
    operationalState: OperationalState,
    createdAt: z
        .string()
        .datetime()
        .transform((v) => parseISO(v)),
    updatedAt: z
        .string()
        .datetime()
        .transform((v) => parseISO(v)),
});
const Response = z.object({
    data: PhysicalAccountSchema,
});
export const url = (physicalAccountId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/account/farther-managed/physical/${physicalAccountId}`
    : `https://middleware.uat.farther.com/account/farther-managed/physical/${physicalAccountId}`;
export default async function getPhysicalAccount(physicalAccountId, config) {
    const { data } = await axios.get(url(physicalAccountId), {
        headers: {
            Version: "20241110",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data.data;
    }
    else {
        const errorMessage = `${getPhysicalAccount.name} Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getPhysicalAccount.js.map